<script setup lang="ts">
import { useUiStore } from '@/stores/ui';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';

const uiStore = useUiStore();

function getIcon(type: string) {
  switch (type) {
    case 'success':
      return CheckCircleIcon;
    case 'error':
      return ExclamationCircleIcon;
    default:
      return InformationCircleIcon;
  }
}

function getClasses(type: string) {
  switch (type) {
    case 'success':
      return 'bg-green-50 dark:bg-green-900/20 text-green-800 dark:text-green-200 border-green-200 dark:border-green-800';
    case 'error':
      return 'bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200 border-red-200 dark:border-red-800';
    default:
      return 'bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-200 border-blue-200 dark:border-blue-800';
  }
}
</script>

<template>
  <div class="fixed bottom-20 lg:bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm w-full">
    <TransitionGroup
      name="toast"
      tag="div"
      class="flex flex-col gap-2"
    >
      <div
        v-for="toast in uiStore.toasts"
        :key="toast.id"
        :class="[
          'flex items-center gap-3 p-4 rounded-lg border shadow-lg',
          getClasses(toast.type),
        ]"
      >
        <component
          :is="getIcon(toast.type)"
          class="w-5 h-5 flex-shrink-0"
        />
        <p class="flex-1 text-sm font-medium">{{ toast.message }}</p>
        <button
          class="flex-shrink-0 p-1 hover:bg-black/5 dark:hover:bg-white/5 rounded"
          @click="uiStore.removeToast(toast.id)"
        >
          <XMarkIcon class="w-4 h-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
